import { createSlice, type PayloadAction } from '@reduxjs/toolkit'
import { type intervalData } from '../services/getFlameSignaGraphDataService'

export interface flowSignalReadingAssetDataState {
  isLoading: boolean
  errorMessage: string | null
  flowSignalReadingData: intervalData | null
  httpStatus: number | null
}

// Initial state of the slice

const initialState: flowSignalReadingAssetDataState = {
  flowSignalReadingData: null,
  isLoading: false,
  errorMessage: null,
  httpStatus: null
}

// Slice to return from action
export const flowSignalDataState = createSlice({
  name: 'flowSignalData',
  initialState,
  reducers: {
    flowSignalDataLoadingAction: (state) => {
      // clear out the data whenever we reload
      return {
        flowSignalReadingData: null,
        isLoading: true,
        errorMessage: null,
        httpStatus: 0
      }
    },
    flowSignalDataUpdateAction: (state, action: PayloadAction<any>) => {
      return {
        flowSignalReadingData: action.payload.data,
        isLoading: false,
        errorMessage: null,
        httpStatus: action.payload.httpStatus
      }
    },
    flowSignalDataErrorAction: (state, action: PayloadAction<{ errorMessage: string, httpStatus: number }>) => {
      return {
        flowSignalReadingData: null,
        isLoading: false,
        errorMessage: action.payload.errorMessage,
        httpStatus: action.payload.httpStatus
      }
    }
  }
})

// Actions to export
export const {
  flowSignalDataLoadingAction,
  flowSignalDataUpdateAction,
  flowSignalDataErrorAction
} = flowSignalDataState.actions

export default flowSignalDataState.reducer
